/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ChannelListItemViewModelPaginatedResponse } from "../types/ChannelListItemViewModelPaginatedResponse.ts";
import { channelListItemViewModelSchema } from "./channelListItemViewModelSchema.ts";

export const channelListItemViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => channelListItemViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<ChannelListItemViewModelPaginatedResponse>;
